import React from 'react';
import {Box, Button, Stack, Typography} from '@mui/joy';
// @ts-ignore
import {ProjectRepository} from "../repository/ProjectRepository";
import {SummaryModel} from "../model/summary";

function Description({summary, resumeURL}: { summary: SummaryModel, resumeURL: string }) {
    return (
        <Stack paddingRight={{md: 4}} alignItems={{md: "start", xs: "center"}} direction="column" spacing={1}>
            <Typography textAlign={{md: "start", xs: "center"}} level='title-lg'>
                Hi, I'm &nbsp;<Typography style={{wordWrap: "normal"}} textAlign={{md: "start", xs: "center"}} fontWeight="lg" color="primary">
                {summary?.firstName.concat(" " + summary?.lastName)}
            </Typography>
            </Typography>

            <Typography textAlign={{md: "start", xs: "center"}} style={{wordWrap: "normal"}} level='title-md' >
               I'm a {summary?.role.join(" & ")}
            </Typography>
            <Typography textAlign="justify">{summary?.profile}</Typography>
            <Box height={4}/>
            <Stack justifyContent={{md: "start", xs: "center"}} direction="row" spacing={2}>
                <a download='Monney Fetchner Developer.pdf' href={resumeURL} target="_blank"><Button>Download
                    Resume</Button></a>
                <a
                    href={summary?.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    style={{textDecoration: "none", padding: 0}}>
                    <Button variant="outlined">Hire Me</Button>
                </a>
            </Stack>
        </Stack>
    );
}

export default Description;
